import React from 'react';
const RadioPublicAttr = {
  type: 'IndividualRadio',
  itemStyles: { display: 'inline-block', width: '100%' },
  titleStyles: { top: '-0.25rem', color: '#DBDBDB' },
  upTextStyles: { color: '#ACACAC' },
  arr: [{ text: 'On-premise' }, { text: 'Cloud' }, { text: 'Unknown' }],
  size: 'large',
};

const CheckBoxPublicAttr = {
  type: 'IndividualCheckBox',
  checkBoxName: 'checkerBoxName',
  itemStyles: { display: 'inline-block', width: '100%' },
  arr: [
    { text: 'Not supported \n by vendor' },
    { text: 'Material level \n of customization' },
    { block: true, classname: 'block' },
  ],
  size: 'large',
};

const seperatorPublicStyles = {
  type: 'Seperator',
  seperatorStyles: { margin: '1.25rem 0' },
};

const ERPData = [
  {
    value: 'Microsoft',
    label: 'Microsoft',
    children: [
      {
        value: 'Dynamics GP',
        label: 'Dynamics GP',
      },
      {
        value: 'Dynamics AX',
        label: 'Dynamics AX',
      },
      {
        value: 'Dynamics 365',
        label: 'Dynamics 365',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'Oracle',
    label: 'Oracle',
    children: [
      {
        value: 'Netsuite Standard',
        label: 'Netsuite Standard',
      },
      {
        value: 'Netsuite OneWorld',
        label: 'Netsuite OneWorld',
      },
      {
        value: 'EBS',
        label: 'EBS',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'SAP',
    label: 'SAP',
    children: [
      {
        value: 'Business One',
        label: 'Business One',
      },
      {
        value: 'ECC 6.0',
        label: 'ECC 6.0',
      },
      {
        value: 'S/4HANA',
        label: 'S/4HANA',
      },
      {
        value: 'R3',
        label: 'R3',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'Intacct',
    label: 'Intacct',
    children: [
      {
        value: 'ERP',
        label: 'ERP',
      },
    ],
  },
  {
    value: 'Sage',
    label: 'Sage',
    children: [
      {
        value: '100cloud',
        label: '100cloud',
      },
      {
        value: '300cloud',
        label: '300cloud',
      },
      {
        value: 'X3',
        label: 'X3',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'Epicor',
    label: 'Epicor',
    children: [
      {
        value: 'ERP',
        label: 'ERP',
      },
    ],
  },
  {
    value: 'Aptean',
    label: 'Aptean',
    children: [
      {
        value: 'Ross',
        label: 'Ross',
      },
      {
        value: 'Encompix',
        label: 'Encompix',
      },
      {
        value: 'Intuitive',
        label: 'Intuitive',
      },
      {
        value: 'Axis',
        label: 'Axis',
      },
      {
        value: 'Cimnet',
        label: 'Cimnet',
      },
      {
        value: 'DTR',
        label: 'DTR',
      },
      {
        value: 'Complete',
        label: 'Complete',
      },
      {
        value: 'Apprise',
        label: 'Apprise',
      },
      {
        value: 'JustFood',
        label: 'JustFood',
      },
      {
        value: 'Made2Manage',
        label: 'Made2Manage',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'Deltek',
    label: 'Deltek',
    children: [
      {
        value: 'Costpoint',
        label: 'Costpoint',
      },
      {
        value: 'Maconomy',
        label: 'Maconomy',
      },
      {
        value: 'Vantagepoint',
        label: 'Vantagepoint',
      },
      {
        value: 'Version Unknown',
        label: 'Version Unknown',
      },
    ],
  },
  {
    value: 'Other',
    label: 'Other',
    // children: [
    //   {
    //     value: '*Free text*',
    //     label: '*Free text*',
    //   },
    // ],
  },
];

const buyerNoAppliactionObj = {
  containerName: 'container-name',
  itemStyles: { position: 'relative' },
  disabled: false,
  hasCheckbox: true,
  checkBoxAttr: {
    name: 'buyerNoApplication',
    checked: false,
    className: 'no-application-check-box',
    label: 'No Application',
  },
};

const targetNoAppliactionObj = {
  containerName: 'container-name',
  itemStyles: { position: 'relative' },
  disabled: false,
  hasCheckbox: true,
  checkBoxAttr: {
    name: 'targetNoApplication',
    checked: false,
    className: 'no-application-check-box',
    label: 'No Application',
  },
};

export const CRMData = [
  'Same vendor as ERP',
  'ActiveCampaign',
  'Apptivo',
  'Creatio',
  'Dynamics 365',
  'Freshsales',
  'HubSpot',
  'Infor Cloudsuite CRM',
  'Insightly',
  'Keap',
  'Netsuite CRM+',
  'Oracle CX Sales',
  'Pipedrive',
  'Sage CRM',
  'Salesforce',
  'SAP CRM',
  'Zendesk',
  'Zoho',
  'Other',
];

export const HCMData = [
  'Same vendor as ERP',
  'ADP Vantage',
  'BambooHR',
  'Kronos Workforce Ready',
  'Oracle HCM Cloud',
  'SAP Successfactors',
  'UltiPro',
  'Workday HCM',
  'Other',
];

const QS28 = {
  arr: [
    {
      type: 'IndividualRadio',
      radioBoxName: 'margin20',
      id: 'chice28',
      name: 'choice',
      upTextStyles: { color: '#ACACAC' },
      itemStyles: { display: 'inline-block', width: '60%' },
      arr: [
        { text: 'Minimal Impact' },
        { text: 'Minor Impact' },
        { text: 'Moderate Impact' },
        { text: 'Major Impact' },
        { text: 'Significant Impact' },
      ],
      size: 'large',
    },
    {
      type: 'TextArea',
      id: 'textArea28',
      label: 'Initiatives Description',
      name: 'text',
      placeholder: 'Please input',
      itemStyles: { width: '70%' },
      classname: 'margin-left13',
      autoSize: { minRows: 3, maxRows: 3 },
    },
  ],
};

const QS29 = {
  arr: [
    {
      type: 'IndividualRadio',
      name: 'choice',
      id: 'chice29',
      upTextStyles: { color: '#ACACAC' },
      itemStyles: { display: 'inline-block', width: '36%' },
      arr: [{ text: 'Minimal' }, { text: 'Partial' }, { text: 'Full' }],
      size: 'large',
    },
  ],
};

const QS30 = {
  arr: [
    {
      type: 'Radio',
      name: 'choice',
      id: 'chice30',
      itemStyles: { display: 'inline-block', width: '24%' },
      arr: ['Yes', 'No'],
      radioBoxName: 'twoChoice',
      size: 'large',
    },
  ],
};

const QS31 = {
  arr: [
    {
      type: 'IndividualRadio',
      name: 'choice',
      id: 'chice29',
      upTextStyles: { color: '#ACACAC' },
      itemStyles: { display: 'inline-block', width: '36%' },
      arr: [{ text: 'Significant' }, { text: 'Moderate' }, { text: 'Minimal' }],
      size: 'large',
    },
  ],
};
const QS32 = {
  buyer: [
    {
      type: 'Div',
      id: 'buyerDivTitle32',
      text: 'Buyer',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },
    // {
    //   type: 'Checkbox',
    //   id: 'Checkbox1',
    //   text: 'Buyer',
    //   name: 'Checkbox1',
    //   itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    // },

    {
      type: 'Cascader',
      id: 'buyerCascader32',
      // className: 'with-check-box-label',
      label: 'Vendor & Version',
      name: 'buyer',
      size: 'large',
      // rules: [{ required: true, message: 'Please input your username!' }],
      options: ERPData,
      ...buyerNoAppliactionObj,
    },

    {
      type: 'Input',
      name: `buyerOther`,
      id: 'buyerOther32',
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      disabled: false,
      size: 'large',
      label: 'If Other, please input',
      placeholder: 'Please input',
      // rules: [{ required: true, message: 'Please input your username!' }],
    },
    {
      type: 'Div',
      id: 'buyerDivRadioTitle32',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'buyerRadio31',
      name: 'buyerradio',
      disabled: false,
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'buyerDivCheckerTitle32',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'buyerChecker32',
      name: 'buyerchecker',
      disabled: false,
      ...CheckBoxPublicAttr,
    },
  ],

  target: [
    {
      type: 'Div',
      id: 'targetDivTitle32',
      text: 'Target',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Cascader',
      id: 'targetCascader32',
      // className: 'with-check-box-label',
      label: 'Vendor & Version',
      name: 'target',
      size: 'large',
      // rules: [{ required: true, message: 'Please input your username!' }],
      options: ERPData,

      ...targetNoAppliactionObj,
    },
    // {
    //   type: 'Div',
    //   itemStyles: { marginTop: 26 },
    //   label: 'Tier',
    //   hasShow: true,
    //   isShow: false,
    //   children: <div />,
    // },
    {
      type: 'Input',
      name: `targetOther`,
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      disabled: false,
      id: 'targetOther32',
      placeholder: 'Please input',
      size: 'large',
      label: 'If Other, please input',
    },
    {
      type: 'Div',
      id: 'targetRadioTitle32',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'targetRadio32',
      name: 'targetradio',
      disabled: false,
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'targetCheckerTitle32',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'targetChecker32',
      name: 'targetchecker',
      disabled: false,
      ...CheckBoxPublicAttr,
    },
  ],
};
const QS33 = {
  buyer: [
    {
      type: 'Div',
      id: 'buyerDivTitle33',
      text: 'Buyer',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Select',
      id: 'buyerSelect33',
      label: 'Application',
      name: 'buyer',
      size: 'large',
      placeholder: 'Please select',
      options: CRMData,

      ...buyerNoAppliactionObj,
    },
    {
      type: 'Input',
      name: `buyerOther`,
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      id: 'buyerOther33',
      placeholder: 'Please input',
      size: 'large',
      label: 'If Other, please input',
      // rules: [{ required: true, message: 'Please input your username!' }],
    },
    {
      type: 'Div',
      id: 'buyerDivRadioTitle33',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'buyerRadio33',
      name: 'buyerradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'buyerDivCheckerTitle33',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'buyerChecker33',
      name: 'buyerchecker',
      ...CheckBoxPublicAttr,
    },
  ],

  target: [
    {
      type: 'Div',
      id: 'targetDivTitle33',
      text: 'Target',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Select',
      id: 'targetSelect33',
      label: 'Application',
      name: 'target',
      size: 'large',
      placeholder: 'Please select',
      options: CRMData,

      ...targetNoAppliactionObj,
    },
    {
      type: 'Input',
      name: `targetOther`,
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      id: 'targetOther33',
      placeholder: 'Please input',
      size: 'large',
      label: 'If Other, please input',
      // rules: [{ required: true, message: 'Please input your username!' }],
    },
    {
      type: 'Div',
      id: 'targetRadioTitle33',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'targetRadio33',
      name: 'targetradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'targetCheckerTitle33',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'targetChecker33',
      name: 'targetchecker',
      ...CheckBoxPublicAttr,
    },
  ],
};

const QS34 = {
  buyer: [
    {
      type: 'Div',
      id: 'buyerDivTitle34',
      text: 'Buyer',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Select',
      id: 'buyerSelect34',
      label: 'Application',
      name: 'buyer',
      size: 'large',
      placeholder: 'Please select',
      options: HCMData,

      ...buyerNoAppliactionObj,
    },
    {
      type: 'Input',
      name: `buyerOther`,
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      id: 'buyerOther34',
      placeholder: 'Please input',
      size: 'large',
      label: 'If Other, please input',
      // rules: [{ required: true, message: 'Please input your username!' }],
    },
    {
      type: 'Div',
      id: 'buyerDivRadioTitle34',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'buyerRadio34',
      name: 'buyerradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'buyerDivCheckerTitle34',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'buyerChecker34',
      name: 'buyerchecker',
      ...CheckBoxPublicAttr,
    },
  ],

  target: [
    {
      type: 'Div',
      id: 'targetDivTitle34',
      text: 'Target',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Select',
      id: 'targetSelect34',
      label: 'Application',
      name: 'target',
      size: 'large',
      placeholder: 'Please select',
      options: HCMData,

      ...targetNoAppliactionObj,
    },
    {
      type: 'Input',
      name: `targetOther`,
      itemStyles: { marginTop: 26 },
      hasShow: true,
      isShow: false,
      id: 'targetOther34',
      placeholder: 'Please input',
      size: 'large',
      label: 'If Other, please input',
      // rules: [{ required: true, message: 'Please input your username!' }],
    },
    {
      type: 'Div',
      id: 'targetRadioTitle34',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      id: 'targetRadio34',
      name: 'targetradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'targetCheckerTitle34',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'targetChecker34',
      name: 'targetchecker',
      ...CheckBoxPublicAttr,
    },
  ],
};

const QS35 = {
  buyer: [
    {
      type: 'Div',
      text: 'Buyer',
      id: 'Buyer35',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Input',
      label: 'Vendor',
      name: 'buyervendor',
      hasShow: false,
      id: 'buyervendor35',
      placeholder: 'Please input',
      classname: 'addingMarginBottom',
      size: 'large',
      ...buyerNoAppliactionObj,
    },
    {
      type: 'Input',
      hasShow: false,
      placeholder: 'Please input',
      label: 'Application',
      name: 'buyerapplication',
      id: 'buyerapplication35',
      size: 'large',
    },
    {
      type: 'Div',
      id: 'Hosted35',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      name: 'buyerradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'applicable35',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'buyer35',
      name: 'buyerchecker',
      ...CheckBoxPublicAttr,
    },
  ],

  target: [
    {
      type: 'Div',
      text: 'Target',
      id: 'target35',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Input',
      label: 'Vendor',
      hasShow: false,
      name: 'targetvendor',
      id: 'targetvendor35',
      placeholder: 'Please input',
      classname: 'addingMarginBottom',
      size: 'large',

      ...targetNoAppliactionObj,
    },
    {
      type: 'Input',
      label: 'Application',
      name: 'targetapplication',
      hasShow: false,
      id: 'targetapplication35',
      placeholder: 'Please input',
      size: 'large',
    },
    {
      type: 'Div',
      id: 'targetHosted35',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      name: 'targetradio',
      id: 'targetradio35',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      id: 'targetdiv35',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      id: 'targetchecker35',
      name: 'targetchecker',
      ...CheckBoxPublicAttr,
    },
  ],
};

const QS36 = {
  buyer: [
    {
      type: 'Div',
      text: 'Buyer',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Input',
      label: 'Vendor',
      hasShow: false,
      name: 'buyervendor',
      placeholder: 'Please input',
      classname: 'addingMarginBottom',
      size: 'large',

      ...buyerNoAppliactionObj,
    },
    {
      type: 'Input',
      label: 'Application',
      hasShow: false,
      placeholder: 'Please input',
      name: 'buyerapplication',
      size: 'large',
    },
    {
      type: 'Div',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      name: 'buyerradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      name: 'buyerchecker',
      ...CheckBoxPublicAttr,
    },
  ],

  target: [
    {
      type: 'Div',
      text: 'Target',
      itemStyles: { marginBottom: 16, fontSize: '1rem', fontWeight: 500 },
    },

    {
      type: 'Input',
      label: 'Vendor',
      hasShow: false,
      name: 'targetvendor',
      placeholder: 'Please input',
      classname: 'addingMarginBottom',
      size: 'large',

      ...targetNoAppliactionObj,
    },
    {
      type: 'Input',
      hasShow: false,
      placeholder: 'Please input',
      label: 'Application',
      name: 'targetapplication',
      size: 'large',
    },
    {
      type: 'Div',
      children: (
        <div>
          Data Hosted on{' '}
          <span style={{ color: '#ACACAC' }}>[Select one option]</span>
        </div>
      ),
      itemStyles: { marginTop: 20 },
    },
    {
      label: 'Buyer',
      name: 'targetradio',
      ...RadioPublicAttr,
    },
    seperatorPublicStyles,
    {
      type: 'Div',
      children: (
        <div style={{ color: '#ACACAC', marginBottom: 10 }}>
          [If applicable: Select those that apply]
        </div>
      ),
      style: { marginTop: 0 },
    },
    {
      label: 'Buyer',
      name: 'targetchecker',
      ...CheckBoxPublicAttr,
    },
  ],
};

const QS37 = {
  arr: [
    {
      type: 'Radio',
      name: 'choice',
      id: 'chice37',
      upTextStyles: { color: '#ACACAC' },
      itemStyles: { display: 'inline-block', width: '36%' },
      arr: [
        'Significant (> 3 deals over the past 5 years)',
        'Moderate (1-3 deals over the past 5 years)',
        'Limited (0 deals over the past 5 years)',
      ],
      size: 'large',
    },
  ],
};
export const QSarr = {
  QS28,
  QS29,
  QS30,
  QS31,
  QS32,
  QS33,
  QS34,
  QS35,
  QS36,
  QS37,
};
